<template>
  <div>
    <pagination v-loading="loading" :data="employeeListData" :option="paginationOption" @search="search" @add="add" @edit="edit"></pagination>
    <el-dialog :close-on-click-modal="false" width="700px" :visible.sync="dialogEditorVisible" top="8vh">
      <adEdit :data="editData" @closeDialog="onCloseEditor" @saveSuccess="onSaveSuccess"></adEdit>
    </el-dialog>
  </div>
</template>

<script>
import pagination from "../common/pagination";
import adEdit from "./adEdit";
import { getEmployees, saveEmployee } from "../../service/user.service";
import imageShow from "@/components/fileHandler/imageShow";
export default {
  data() {
    return {
      loading:false,
      listData:[],
      employeeListData: [],
      paginationOption: {},
      editData:{},
      editIndex:-1,
      dialogEditorVisible: false,
      searchKeyword:''
    };
  },
  components: {
    pagination,
    adEdit, 
    imageShow
  },
  created() {
    this.getEmployeeListData("");
    this.paginationOption = {
      displayPagination: false,
      hasEditButton: this.USERMANAGER.isManager || this.USERMANAGER.isAdmin,
      editButtonText: "编辑广告",
      hasAddButton: true,
      addButtonText: "添加广告",
      hasSearch: true,
      fnRowEditVisible: this.onRowEditVisible
    };
  },
  methods: {
    onCloseEditor(){
      this.dialogEditorVisible = false;

    },
    onSaveSuccess(isAdd, row){
      this.dialogEditorVisible = false;     
      this.getEmployeeListData(this.searchKeyword);
    },
    search(keyword) {
      this.searchKeyword = keyword;
      this.getEmployeeListData(keyword);
    },
    add() {
      this.editData = {};
      this.dialogEditorVisible = true;
    },
    edit(index, row) {
      this.editIndex = index;
      this.editData = row;
      this.dialogEditorVisible = true;
    },
    getEmployeeListData(keyword) {
      this.loading = true;
      let roleTypes = [
        this.GLOBAL.roleType.sales,
        this.GLOBAL.roleType.assistant,
        this.GLOBAL.roleType.receptionist,
        this.GLOBAL.roleType.executiveManager,
        this.GLOBAL.roleType.educationalAssistant,
        this.GLOBAL.roleType.internationalSales,
      ];
      getEmployees(roleTypes, keyword, null).then(result => {
        if (result && result.success) {
          this.employeeListData = result.data;
        }
        this.loading = false;
      });
    },
    onRowEditVisible(index,row){
      if(this.USERMANAGER.isAdmin)
      return true;
      if(this.USERMANAGER.isManager){ 
        if(row.RoleId == this.GLOBAL.roleType.executiveManager || 
           row.RoleId == this.GLOBAL.roleType.financialManager){
             return false;
          }
          else{
            return true;
          }
      }
      else{
        return false;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/advertistings/adList.vue